<template>
    <div>
        <div class="row">
            <div class="col-md-8 col-md-offset-2">
                <div class="HelpCenter__video embed-responsive embed-responsive-16by9">
                    <iframe class="embed-responsive-item"
                            :src="activeVideoSrc"
                            frameborder="0"
                            allowfullscreen
                    ></iframe>
                </div>
            </div>
        </div>

        <div class="HelpCenter__video-images row">
            <div class="col-md-8 col-md-offset-2">
                <div class="col-md-1">&nbsp;</div>
                <div class="col-md-2" v-for="video in videos">
                    <a href="#" :class="videoImageClasses(video)" @click.prevent="selectVideo(video)">
                        <img :src="video.image">
                        {{ video.name }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                videos: [
                    { id: 'eqqbYOUL8ds', name: 'Introduction to Motorstats', image: '/images/help-center/video-1.jpg', isActive: true },
                    { id: 'AuqGu2muaoY', name: 'Accessing Reports and using Filters', image: '/images/help-center/video-2.jpg', isActive: false },
                    { id: '9iSYl5ypP7w', name: 'Creating and utilizing Saved Filters', image: '/images/help-center/video-3.jpg', isActive: false },
                    { id: 'vFd8GXikLHI', name: 'Charts for Used Imports', image: '/images/help-center/video-4.jpg', isActive: false },
                    { id: 'Ma-JXszXofE', name: 'Accessing Detailed Reporting', image: '/images/help-center/video-5.jpg', isActive: false },
                ],

                clicked: false,
            }
        },

        computed: {
            activeVideo() {
                return _.find(this.videos, ['isActive', true]);
            },

            activeVideoSrc() {
                return 'https://www.youtube.com/embed/' + this.activeVideo.id + '?rel=0&amp;showinfo=0' +
                    (this.clicked ? '&amp;autoplay=1' : '');
            }
        },

        methods: {
            videoImageClasses(video) {
                return {
                    'HelpCenter__video-image': true,
                    'HelpCenter__video-image--is-active': video.isActive,
                }
            },

            selectVideo(selectedVideo) {
                this.clicked = true;

                this.videos.forEach(video => {
                    video.isActive = (video.id == selectedVideo.id);
                })
            }
        }
    }
</script>